import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { routerShape, withRouter } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButtonsToolbar, PrintLoadNextButton, PrintTable } from '@bibliocommons/print';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

export class SearchPrintList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdatePage');
  }

  handleUpdatePage() {
    const { router } = this.props;
    const { location } = router;

    const newPage = this.props.pagination.get('page') + 1;
    this.props.router.push({
      ...location,
      query: { ...location.query, pagination_page: newPage }
    });
  }

  render() {
    const { pagination, results, searchQuery, isFetching } = this.props;

    return (
      <div className="cp-search-print-list">
        <PrintButtonsToolbar numItemsToPrint={results.size}>
          <PrintLoadNextButton
            handleClick={this.handleUpdatePage}
            numToLoad={pagination.get('limit')}
            totalPages={pagination.get('pages')}
            currentPage={pagination.get('page')}
            isLoading={isFetching} />
        </PrintButtonsToolbar>
        <h1 className="page-header">
          <FormattedMessage id="print_search_for" values={{ search_name: searchQuery.get('query') }} />
        </h1>
        <p>
          <FormattedMessage id="label_number_of_items" values={{ count: pagination.get('count') }} />
        </p>
        <PrintTable
          rows={results}
          fields={[
            { key: 'title', type: 'item-title', headerKey: 'table_headings_title' },
            { key: 'subtitle', type: 'subtitle-title', headerKey: 'table_headings_subtitle' },
            { key: 'authors', type: 'item-author', headerKey: 'table_headings_author' },
            { key: 'format', type: 'item-format', headerKey: 'table_headings_format', localizationMap: val => `FORMAT.${val.toLowerCase()}` },
            { key: 'callNumber', type: 'item-call-number', headerKey: 'table_headings_call_number' }
          ]} />
        <div className="page-info">
          <FormattedMessage id="form_label_current_page" values={{ current_page: pagination.get('page') }} />
          &nbsp;
          <FormattedMessage id="form_label_total_pages" values={{ total_pages: pagination.get('pages') }} />
        </div>
      </div>
    );
  }
}

SearchPrintList.propTypes = {
  pagination:     ImmutablePropTypes.map,
  results:        ImmutablePropTypes.list,
  searchQuery:    ImmutablePropTypes.map,
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isFetching: PropTypes.bool,
  router: routerShape.isRequired
};

export default withRouter(SearchPrintList);



// WEBPACK FOOTER //
// ./app/components/search/SearchPrintList/SearchPrintList.jsx